<template>
  <Modal
    :open="displayModal"
    title="Reset Password"
    size="large"
    modalIcon="fad fa-user"
    modalIconColor="bg-blue-100 text-blue-700"
    :showEscapeButton="true"
    :showAcceptButton="true"
    acceptButtonText="Reset"
    :acceptButtonProgress="loading"
    @close="displayModal = false"
    @onSuccess="submitPassword"
    ref="modal"
  >
    <div class="grid grid-cols-1 gap-4">
      <div>
        <label
          for="user_permission"
          class="block text-sm font-medium text-gray-700 mb-1"
          >Reset Type</label
        >
        <select
          id="user_permission"
          name="user_permission"
          class="block w-full focus:ring-blue-500 focus:border-blue-500 border-gray-300 rounded-md"
          v-model="resetType"
        >
          <option value="manual">Manually Entry</option>
          <option value="random">Random Password</option>
        </select>
      </div>

      <div>
        <label
          for="userPassword"
          class="block text-sm font-medium text-gray-700"
          >Password</label
        >
        <div class="flex flex-row">
          <div class="relative flex items-stretch flex-grow">
            <input
              class="focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300"
              id="userPassword"
              type="text"
              v-model="password"
              :class="{
                'rounded-md': resetType == 'manual',
                'rounded-none rounded-l-md': resetType == 'random'
              }"
            />
          </div>
          <button
            class="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
            v-on:click="makePassword"
            v-if="resetType == 'random'"
          >
            <i class="fa fa-sync"></i>
          </button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import * as Config from "@/config";
import { mapActions } from "vuex";

import Modal from "@/components/Modal";

export default {
  data() {
    return {
      displayModal: false,
      userData: null,
      resetType: "manual",
      password: null,
      loading: false
    };
  },

  components: {
    Modal
  },

  mounted() {
    this.$nextTick(
      function() {
        this.$eventBus.$on("admin-user-reset-password-modal-open", this.open);
      }.bind(this)
    );
  },

  destroyed() {
    this.$eventBus.$off("admin-user-reset-password-modal-open", this.open);
  },

  methods: {
    ...mapActions(["addToastMessage"]),
    open(data) {
      console.log(data);
      this.displayModal = true;
      this.userData = data;
    },

    makePassword() {
      var text = "";
      var possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      for (var i = 0; i < 20; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      this.password = text;
    },

    async submitPassword() {
      this.loading = true;

      let res = await this.$http.post(
        Config.apiPath +
          "/api/v2/admin/users/" +
          this.userData.id +
          "/password",
        { password: this.password }
      );
      if (res.status == 200) {
        this.loading = false;

        this.addToastMessage({
          title: "Success",
          text: this.userData.name + "'s password was updated.",
          type: "success"
        });

        this.displayModal = false;
      } else {
        this.addToastMessage({
          title: "Whoops!",
          text:
            this.userData.name + "'s password was not updated due to an issue.",
          type: "error"
        });
      }
    }
  },
  watch: {
    resetType: function(data) {
      if (data == "random") {
        this.makePassword();
      }
      return data;
    }
  }
};
</script>
